<template>
  <modal :open="open">
    <template slot="content">
      <div class="emd-container _highlight_header _footer_end">
        <div class="emd-container__header">
          <jade-text variant="heading-xsmall">{{ $t('title') }}</jade-text>
          <jade-icon-button
            icon="close"
            size="small"
            variant="neutral-ghost"
            @click="handleCloseModal"
          >
          </jade-icon-button>
        </div>
        <div class="emd-container__content !p-0">
          <jade-list-item
            :label="$t('customerName')"
            :trailing="name"
          />
          <jade-list-item
            :label="$t('customerEmail')"
            :trailing="email"
          />
          <jade-list-item
            :label="$t('confirmedValue')"
            :trailing="value"
          />
          <jade-list-item
            :label="$t('transaction')"
            :trailing="value"
          />
        </div>
        <jade-divider />
        <div class="emd-container__footer gap-2">
          <jade-button
            variant="neutral-subtle"
            size="medium"
            @click="handleCloseModal"
          >
            {{ $t('close') }}
          </jade-button>
          <jade-button
            variant="primary-solid"
            size="medium"
            @click="handleConfirm"
          >
            {{ $t('confirm') }}
          </jade-button>
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
import apiClient from '@pagarme/http-client'
import {
  JadeIconButton,
  JadeButton,
  JadeText,
  JadeListItem,
  JadeDivider
} from '@/components/jade'
export default {
  name: 'SimulatePaymentsModal',
  components: {
    JadeIconButton,
    JadeText,
    JadeListItem,
    JadeButton,
    JadeDivider,
    Modal: () => import('@/components/project/globals/Modal.vue')
  },
  props: {
    open: Boolean,
    name: String,
    email: String,
    value: Number,
    transactionId: String
  },

  methods: {
    handleCloseModal () {
      this.$emit('handleClose')
    },
    async handleConfirm () {
      try {
        const client = apiClient()
        await client.sales.simulatePayments(this.transactionId)
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)
      } finally {
        this.handleCloseModal()
      }
    }
  }
}
</script>
<i18n>
  {
    "pt-BR": {
      "title": "Confirme os dados do pagameto",
      "customerName": "Nome do cliente",
      "customerEmail": "E-mail",
      "confirmedValue": "Valor confirmado",
      "transaction": "Valor da transação",
      "close": "Fechar",
      "confirm": "Confirmar"
    },
    "en-US": {
      "title": "Confirm payment data",
      "customerName": "Customer name",
      "customerEmail": "E-mail",
      "confirmedValue": "Confirmed value",
      "transaction": "Transaction value",
      "close": "Close",
      "confirm": "Confirm"
    }
  }
</i18n>
